import { createSlice } from "@reduxjs/toolkit";

export type PaymentGatewayProps={
    threedHtml: string
}
export const paymentGatewaySlice = createSlice({
  name: "paymentGateway",
  initialState: {
    threedHtml: "", 
  },
  reducers: {
    updateThreedHtml: (state, action) => {
      state.threedHtml = action.payload;
      return state;
    },
    clearThreedHtml: (state) => {
      state.threedHtml = "";
      return state;
    },
  },
});
export const { clearThreedHtml, updateThreedHtml } = paymentGatewaySlice.actions;

export const paymentGatewaySelector = (state:any) => state.paymentGateway;

export const paymentGatewayReducer = paymentGatewaySlice.reducer;